import clipboard from 'clipboard';
import store from '../store/index'; // 这种方式才是导入了实例
// import { getModuleList } from "@/api/addModule";

// 复制文本
export function copyText(text) {
  clipboard.copy(text);
}

// 区分三期和四期url
export function matchingUrl(url) {
  switch (store.state.pageNum) {
    case '1': //听说图书
      break;
    case '2': //听说精练
      url = '/stage4' + url;
      break;
  }
  return url;
}

let regionCode = {
  北京: '110000',
  广东: '440000',
  云南: '530000',
  宁夏: '640000',
  东莞: '441900',
  佛山: '440600',
  珠海: '440400',
  中山: '442000',
  山东: '370000',
  淄博: '370300',
  湖北: '420000',
  贵州: '520000',
  梅州: '441400',
};
export { regionCode };

export function getRegionCode(name) {
  if (name.indexOf('/') != -1) {
    let arr = name.split('/');
    name = arr[arr.length - 1];
  }
  console.log(name);
  return regionCode[name];
}

export function getModuleType(name, _this) {
  if (name instanceof Array) {
    name = name[0];
  }

  let type = _this.$route.query.type;
  if (!type) {
    let moduleName = sessionStorage.getItem('editModuleName');
    console.log(moduleName);
    if (moduleName) {
      if (moduleName.indexOf('/') != -1) {
        return 2;
      } else {
        return 1;
      }
    } else {
      return 1;
    }
  }

  let bookId = _this.$route.query.bookId;
  let module = JSON.parse(sessionStorage.getItem('moduleData'));
  let bookModule = module?.find((el) => el.bookId == bookId);

  if (!bookModule) {
    return 0;
  }
  bookModule = bookModule.catalogList;
  let leveModule = bookModule.find((el) => el.catalogType == name) || '';

  if (leveModule.subtypeList) {
    if (leveModule.subtypeList.length) {
      return 2;
    } else {
      return 1;
    }
  } else {
    return 1;
  }
}

// 套卷发布状态
export const publishStatusMap = [
  {
    value: 0,
    label: '未发布',
    type: 'danger',
  },
  {
    value: 1,
    label: '已发布',
    type: 'success',
  },
  {
    value: 2,
    label: '修改未发布',
    type: 'warning',
  },
];

export const getPublishStatusKey = (publish, key = 'label') => {
  let releaseStatus = publishStatusMap.find((el) => el.value == publish);
  return releaseStatus?.[key] || '未知';
};
export const getPublishStatus = (publish) => {
  let releaseStatus = publishStatusMap.find((el) => el.value == publish);
  return releaseStatus || {};
};

export const answerMethodMap = [
  {
    /*
     * 回答问题对映的原类型：
     * expressionAnswerAfterListening 听后回答
     * expressionShortDialogueAnswer 听短对话，回答问题
     * expressionLongDialogueAnswer 听长对话，回答问题
     * expressionMonologueAnswer 听独白回答问题
     * expressionSelectInformation 听选信息
     * expressionAnswerQuestion 回答问题
     * expressionAskQuestion 询问信息
     * expressionDialogue 日常对话
     * expressionDialogue 情景问答
     * dialogue 情景对话
     * wordsToSentence 连词成句
     * ?听句子选读正确应答语
     * ?情景提问
     * ?情景交际
     * ?情景反应
     */
    value: 'expressionAnswerAfterListening',
    label: '回答问题',
  },
  {
    /*
     * 口语表达对映的原类型：
     * retellOralComposition 口头作文
     * ?口头表达
     */
    value: 'retellOralComposition',
    label: '口语表达',
  },
  {
    /*
     * 朗读题对映的原类型：
     * readWord 朗读
     * readChapter 朗读短文
     * readChapterAfterTape 模仿朗读
     * ?短文朗读
     */
    value: 'readChapter',
    label: '朗读题',
  },
  {
    /*
     * 填空题对映的原类型：
     * recordAfterListen 听后记录
     * essayFillBlanks 听短文，完成表中所缺信息，每空仅填一词
     * essayFillForm 听短文，填写表格
     * ?听后记录信息
     */
    value: 'recordAfterListen',
    label: '填空题',
  },
  {
    /*
     * 选择题对映的原类型：
     * choiceAfterHearing 听后选择
     * choicePictureAfterSentence 听句子选择图片
     * choiceAnswerAfterSentence 听句子选择答案
     * shortDgeChoiceImg 听短文，选择图片/听短对话，选择图片
     * choiceAnswerAfterDialogue 听对话选择答案
     * choiceDialogueUnderstanding 对话理解
     * choiceEssayUnderstanding 短文理解
     * choiceShortDialogueAnswer 听短对话回答问题
     * choiceLongDialogueAnswer 听长对话回答问题
     * choiceListeningEssayAnswer 听短文回答问题
     * dialogueChoiceImg 听对话，选择与对话内容相符的图片
     * sentenceChoiceAnswer 听句子，选择与句子匹配的最佳应答
     * dialogueChoiceSentence 听对话，选择最佳选项完成句子
     * dialogueChoiceAnswer 听对话，根据对话内容及问题，选择最佳选项
     * shortDgeChoiceAnswer 听短对话，选择答案
     * longDgeChoiceAnswer 听长对话，选择答案
     * ?听句子选择关键信息
     * ?听对话回答问题
     * ?听力理解
     */
    value: 'choiceQuestions',
    label: '选择题', // 听后选择（支持文本、图片）
  },
  {
    /*
     * 转述题对映的原类型：
     * retellAfterListening 听后转述
     * retellExpressingInformation 信息转述
     * retellTopicOverview 话题简述
     * ?听后记录信息
     */
    value: 'retellAfterListening',
    label: '转述题',
  },
];

const queTypeMap = [
  {
    value: 'readWord',
    label: '朗读',
    methodValue: 'readChapter',
  },
  {
    value: 'readChapter',
    label: '朗读短文',
    methodValue: 'readChapter',
  },
  {
    value: 'readChapterAfterTape',
    label: '模仿朗读',
    methodValue: 'readChapter',
  },
  {
    value: 'choiceAfterHearing',
    label: '听后选择',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'choicePictureAfterSentence',
    label: '听句子选择图片',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'choiceAnswerAfterSentence',
    label: '听句子选择答案',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'choiceAnswerAfterDialogue',
    label: '听对话选择答案',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'choiceDialogueUnderstanding',
    label: '对话理解',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'choiceEssayUnderstanding',
    label: '短文理解',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'choiceShortDialogueAnswer',
    label: '听短对话回答问题',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'choiceLongDialogueAnswer',
    label: '听长对话回答问题',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'choiceListeningEssayAnswer',
    label: '听短文回答问题',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'expressionMonologueAnswer',
    label: '听独白回答问题',
    methodValue: 'expressionAnswerAfterListening',
  },
  {
    value: 'expressionAnswerAfterListening',
    label: '听后回答',
    methodValue: 'expressionAnswerAfterListening',
  },
  {
    value: 'expressionShortDialogueAnswer',
    label: '听短对话，回答问题',
    methodValue: 'expressionAnswerAfterListening',
  },
  {
    value: 'expressionLongDialogueAnswer',
    label: '听长对话，回答问题',
    methodValue: 'expressionAnswerAfterListening',
  },
  {
    value: 'expressionSelectInformation',
    label: '听选信息',
    methodValue: 'expressionAnswerAfterListening',
  },
  {
    value: 'expressionAnswerQuestion',
    label: '回答问题',
    methodValue: 'expressionAnswerAfterListening',
  },
  {
    value: 'expressionAskQuestion',
    label: '询问信息',
    methodValue: 'expressionAnswerAfterListening',
  },
  {
    value: 'expressionDialogue',
    label: '日常对话',
    methodValue: 'expressionAnswerAfterListening',
  },
  {
    value: 'expressionQuestionAnswer',
    label: '情景问答',
    methodValue: 'expressionAnswerAfterListening',
  },
  {
    value: 'retellAfterListening',
    label: '听后转述',
    methodValue: 'retellAfterListening',
  },
  {
    value: 'retellExpressingInformation',
    label: '信息转述',
    methodValue: 'retellAfterListening',
  },
  {
    value: 'retellOralComposition',
    label: '口头作文',
    methodValue: 'retellOralComposition',
  },
  {
    value: 'retellTopicOverview',
    label: '话题简述',
    methodValue: 'retellAfterListening',
  },
  {
    value: 'recordAfterListen',
    label: '听后记录',
    methodValue: 'recordAfterListen',
  },
  {
    value: 'dialogue',
    label: '情景对话',
    methodValue: 'expressionAnswerAfterListening',
  },
  //新增
  {
    value: 'dialogueChoiceImg',
    label: '听对话，选择与对话内容相符的图片',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'sentenceChoiceAnswer',
    label: '听句子，选择与句子匹配的最佳应答',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'dialogueChoiceSentence',
    label: '听对话，选择最佳选项完成句子',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'dialogueChoiceAnswer',
    label: '听对话，根据对话内容及问题，选择最佳选项',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'essayFillBlanks',
    label: '听短文，完成表中所缺信息，每空仅填一词',
    methodValue: 'recordAfterListen',
  },
  {
    value: 'shortDgeChoiceImg',
    label: '听短对话，选择图片',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'shortDgeChoiceAnswer',
    label: '听短对话，选择答案',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'longDgeChoiceAnswer',
    label: '听长对话，选择答案',
    methodValue: 'choiceQuestions',
  },
  {
    value: 'essayFillForm',
    label: '听短文，填写表格',
    methodValue: 'recordAfterListen',
  },
  {
    value: 'wordsToSentence',
    label: '连词成句',
    methodValue: 'expressionAnswerAfterListening',
  },
];
export { queTypeMap };

/**
 * 等待指定的毫秒数
 * @param {number} ms - 等待的毫秒数
 * @returns {Promise<void>} - 一个 Promise，在等待完成后解析
 */
export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));